import _ from "lodash";
import {
  DATA_GRID_COLUMN_TYPES,
  EMPTY_CELL,
  EMPTY_CELL_WITH_CENTERED_DASH,
} from "../constants";
import { getFormattedUserName } from "Utils/GetFormattedUserName";
import { formatDate } from "Utils";
import { DATE_TIME_CONSTANTS } from "Constants/dateTimeConstants";

const getLabelCellProps = ({
  node,
  cellConfig,
  customConfig,
  columnId,
  currentNode,
  actionHandlerFn,
}) => {
  const { styles } = cellConfig || {};
  const {
    property,
    showEmptyCellAsFallback = false,
    prefix,
    getCellConfigFromValue,
  } = customConfig || {};

  const value = _.get(node, property);

  switch (columnId) {
    case DATA_GRID_COLUMN_TYPES.LIST_PARENT: {
      const { parentUID } = currentNode?.metadata || {};
      return {
        ...cellConfig,
        value: parentUID || "-",
      };
    }

    case DATA_GRID_COLUMN_TYPES.POWER_STANDARD: {
      if (value) {
        return {
          ...cellConfig,
          value: "",
          prefix: prefix,
        };
      }

      return {
        ...EMPTY_CELL_WITH_CENTERED_DASH,
        styles: {
          align: "center",
          ...styles,
        },
      };
    }

    case DATA_GRID_COLUMN_TYPES.LAST_UPDATED_BY: {
      const { updatedBy, updatedAt } = node;

      const { firstName, lastName, profileImage } = updatedBy || {};

      return {
        ...cellConfig,
        value: getFormattedUserName({ user: updatedBy }),
        subtitle: formatDate({
          date: updatedAt,
          format: DATE_TIME_CONSTANTS.Do_MMM_YYYY_h_mm_A,
        }),
        prefix: [
          {
            type: "avatar",
            name: `${firstName?.charAt(0) || ""}${lastName?.charAt(0) || ""}`,
            src: profileImage,
          },
        ],
      };
    }

    default:
      break;
  }

  if (!value && showEmptyCellAsFallback) return { ...EMPTY_CELL, styles };
  const updatedCellConfig =
    getCellConfigFromValue?.({
      actionHandlerFn,
      value,
      node,
    }) || {};
  return {
    ...cellConfig,
    value,
    ...updatedCellConfig,
  };
};

export default getLabelCellProps;
